module.exports = __webpack_public_path__ + "img/9788958074168.06d37ec8.jpg";